import React, { useEffect, useState } from 'react'
import Loader from 'react-loaders'; 
import AnimatedLetters from '../../Component/AnimatedLetters';
import './about.scss';
const About = () => {
    const [letterClass, setLetterClass] = useState('text-animate');
    useEffect(() => {
        setTimeout(() => {     setLetterClass('text-animate-hover')
         }, 3000)
       }, [])
    return (
    <>
        <div className='about-page container'>
        <div className="text-zone">
            <h1>
                <AnimatedLetters 
                letterClass={letterClass}
                strArray={['A','b','o','u','t',' ','m','e']}
                idx={15} />
            </h1>
            <p>
            Hey there, I'm a programmer and software engineer, and I've got a pretty cool superpower - I can turn coffee into code! With two years of professional experience, I've learned the art of working hard and working smart, and trust me, that's not just about keyboard shortcuts. 
            </p>
            <br />
            <p>
            I'm ready to take on new challenges as a full-stack developer, a system design freelancer, or even the tech lead in a company. Let's code the world, one laugh and one line of code at a time!                
            </p>
            
        </div>
        </div>
        <Loader type="pacman" />
    </>
  )
}

export default About